import { SearchField } from '@heroui/react';
import { useTranslation } from 'react-i18next';

export const BrandSearchField = () => {
    const { t } = useTranslation('pages');
    return (
        <SearchField
            aria-label={t(
                'products.components.productTable.filters.brandSearch',
            )}
            autoFocus
            name="product-filters-brand-search"
            variant="secondary"
        >
            <SearchField.Group>
                <SearchField.SearchIcon />
                <SearchField.Input
                    placeholder={t(
                        'products.components.productTable.filters.brandSearch',
                    )}
                />
                <SearchField.ClearButton />
            </SearchField.Group>
        </SearchField>
    );
};
